import React, {Component} from 'react'
import fire from '../../../../database/firebase'
import styled from 'styled-components'
import shortid from 'shortid';
import ClipLoader from "react-spinners/ClipLoader";
import firebase from "firebase/app";
import { getAuth, linkWithCredential, EmailAuthProvider } from "firebase/auth";
import "firebase/auth";
import Countdown from 'react-countdown';
import LoginComponentSm from './LoginComponentSm';

const Container = styled.div`
    width: 100%;
    height: auto;
    background-color: white;
    //   padding: 1%;
    position: relative; /* Position relative to contain the dropdown */
    text-align: right;
    border-bottom: 0.5px solid #321d05;
    padding-bottom: 2%;
`;

const Button = styled.button`
    background-color: #007bff;
    color: #fff;
    padding-left: 4%;
    padding-right: 4%;
    cursor: pointer;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-right: 3.5%;
    background-color: white;
    border-radius: 8px;
    border: 1px solid #321d05;
    margin-top: 4%;
`;

const Dropdown = styled.div`
    position: absolute;
    top: 100%; /* Position the dropdown below the button */
    left: 0;
    width: 96%; /* Expand the dropdown to the full width of the container */
    display: ${props => (props.open ? 'block' : 'none')}; /* Show/hide the dropdown */
    background-color: #321d05;
    color: #fff;
    padding: 10px;
    //   border: 0.7px solid white;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    font-family: sora;
    // border-bottom-left-radius: 10px;
    // border-bottom-right-radius: 10px;
    transition: max-height 0.3s ease-in, opacity 0.3s ease-in; /* Add transitions */
    max-height: ${props => (props.open ? '200px' : '0')}; /* Set max-height for smooth expansion and collapse */
    overflow: hidden; /* Hide overflow content */
    opacity: ${props => (props.open ? '1' : '0')}; /* Set opacity for fade-in and fade-out */
`;

const Styles = styled.div `

    // - - FULL PAGE - - //

.fullPage {
    width: 100%;
    height: auto;
}

    // - - - NAVBAR - - //

.menu-btn {
    width: 25px;
    height: 25px;
}

    // - - SIGN UP PAGE LOADING - - //

.signUpPageLoading {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 75vh; /* This will make the container take the full viewport height */
    text-align: center;
}

.signUpPageLoading p {
    font-size: 18px; /* Customize font size */
    margin-top: 10px; /* Add spacing between the spinner and the label */
}

    // - - SIGN UP PAGE VERIFICATION

.verificationInput {
    margin-left: 2.5%;
    margin-bottom: 7.5%;
}

.verificationInput input {
    margin-top: 4.5%;
    outline: none;
    text-align: center;
    width: 94%;
    font-size: 45px;
    padding: 1.5%;
    border-radius: 8px;
}

.resendOTP {
    text-align: center;
    margin-bottom: 5%;
}

.resendOTP p {
    font-family: Sora;
    color: #321d05;
    font-weight: bold;
}

.resendOTP button {
    background-color: #321d05;
    padding: 3%;
    border-radius: 8px;
    color: white;
    font-family: sora;
    border: 2px solid #321d05;
    font-size: 90%;
}

    // - - - - - REGISTRATION HEADER - - - - - //

.registrationHeader {
    margin-left: 2.5%;
    margin-right: 2.5%;
}

.registrationHeader h1 {
    color: #321d05;
    font-family: Lato;
}

.registrationHeader h2 {
    color: #321d05;
    font-family: Lato;
}

    // - - - - - REGISTRATION INPUT DETAILS - - - - - //

    // - - INPUT STYLE - - //

.inputStyle {
    margin: auto;
    height: auto;
    width: 95%;
}

.inputBox {
    margin-bottom: 5%;
    padding: 1%;
    border-radius: 8px;
    position: relative;
    // width: 85%;
}

.inputBox h5 {
    font-size: 14px;
    margin-top: 1.5%;
    margin-bottom: 0px;
    margin-left: 1%;
    font-family: sora;
}

.inputBox label {
    float: right;
    color: red;
    font-weight: bold;
    // margin-left: 2.5%;
    margin-right: 2.5%;
}

.inputBox input {
    margin-top: 0px;
    padding-top: 0px;
    padding-bottom: 1%;
    padding-left: 1%;
    width: 90%;
    font-size: 20px;
    outline: none;
    border: 1px solid transparent;
}

.inputBox input[style="display: none"] {
    display: block !important;
}

    // - TERMS AND AGREEMENT BOX - //

.termsAgreement {
    margin-bottom: 5%;
}

.termsAgreement:after {
    content: "";
    display: table;
    clear: both;
}

.termsAgreementCol1 {
    float: left;
    text-align: center;
    width: 10%;
}

.termsAgreementCol2 {
    float: left;
    text-align: left;
    width: 90%;
}

.termsAgreementCol1 img {
    width: 90%;
}

.termsAgreementCol1 img:hover {
    width: 92%;
}

.termsAgreementCol2 p {
    margin-top: 2%;
    margin-left: 2.5%;
}

.termsAgreementCol2 label {
    font-weight: bold;
}

.termsAgreementCol2 label:hover {
    text-decoration: underline;
}

    // - - SIGN UP BUTTON - - //

.signUpBtn {
    margin-left: 2.5%;
}

.signUpBtn button {
    // margin-bottom: 5%;
    background-color: #321d05;
    width: 97.5%;
    color: white;
    padding: 6.5%;
    font-family: sora;
    font-size: 110%;
    border-radius: 7px;
}

    // - - THE LOGIN SEPARATOR - - //

.loginSeparator {
    margin-top: 2.5%;
    margin-bottom: 5%;
}

.loginSeparator:after {
    content: "";
    display: table;
    clear: both;
}

.loginSeparatorCol1 {
    float: left;
    text-align: center;
    width: 45%;
}


.loginSeparatorCol2 {
    float: left;
    text-align: center;
    width: 10%;
}

.loginSeparatorCol3 {
    float: left;
    text-align: center;
    width: 45%;
}

.theSeparatorLine {
    border-top: 2px solid #321d05;
    margin-top: 15%;
    margin-left: 7.5%;
    margin-right: 7.5%;
}

.loginSeparatorCol2 p {
    margin-bottom: 0px;
    font-family: Sora;
    font-weight: bold;
    color: #321d05;
}

    // - - LOGIN ERROR MESSAGE - - //

.loginErrMsg {
    font-weight: bold;
    color: red;
    font-family: sora;
}

    // - - NETWORK ERROR MESSAGE - - //

.signUpPageError {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 75vh; /* This will make the container take the full viewport height */
    text-align: center;
}

.signUpPageError img {
    // margin-top: 25%;
    width: 20%;
}

.signUpPageError h4 {
    color: #0930cb;
    font-family: sora;
    margin-top: 1.5%;
    margin-bottom: 3%;
}

.signUpPageError p {
    margin-top: 0px;
    color: #0930cb;
    font-family: gabarito;
    font-weight: bold;
}

.signUpPageError button {
    margin-top: 1%;
    background-color: #0930cb;
    color: white;
    font-family: sora;
    padding: 3.5%;
    border: 2px solid #0930cb;
    border-radius: 8px;
    font-size: 85%;
}

    // - - FOOTER - - //

.footer {
    margin-top: 10%;
    text-align: center;
    margin-bottom: 7.5%;
}

.footer p {
    color: #321d05;
}


`

export default class SignUpCustomerSm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            showNavbar: false,
            showSignUpPage: false,
            showUserMobileVerification: false,
            showVerificationCountdown: true,
            showResendOTP: false,
            showSignUpPageLoading: false,
            loadingMessage: "",
            signUpHeader: "Psst... we finally have a loyalty program!",
            signUpSubheader: "Sign up here 👇🏿",

            currentClient: "",
            userID: "",
            userCardNumber: "",
            userIDVerified: false,
            cardNumberVerified: false,
            emailVerified: false,
            phoneNumberVerified: false,

                // - - SIGN UP INPUT FIELDS - - //

            firstName: "",
            firstNameBorderColor: "#ABA9A9",
            firstNameTextColor: "#ABA9A9",

            lastName: "",
            lastNameBorderColor: "#ABA9A9",
            lastNameTextColor: "#ABA9A9",

            email: "",
            emailBorderColor: "#ABA9A9",
            emailTextColor: "#ABA9A9",

            phone: "",
            phoneBorderColor: "#ABA9A9",
            phoneTextColor: "#ABA9A9",

            password: "",
            passwordBorderColor: "#ABA9A9",
            passwordTextColor: "#ABA9A9",

            confirmPassword: "",
            confirmPasswordBorderColor: "#ABA9A9",
            confirmPasswordTextColor: "#ABA9A9",

            showTermsChecked: false,
            showTermsUnchecked: true,
            showTermsNotChecked: false,

            areaCodeNumber: "",
            appVerifier: "",
            confirmationResult: "",
            verificationCode: "",
            userCredential: "",
            countdownActive: true,
            OTPCountdownTimer: Date.now() + 59000,
        }
        this.firstNameInputRef = React.createRef();
        this.lastNameInputRef = React.createRef();
        this.emailInputRef = React.createRef();
        this.phoneInputRef = React.createRef();
        this.passwordInputRef = React.createRef();
        this.confirmPasswordInputRef = React.createRef();
    }

    componentDidMount = () => {
        const url = window.location.href
        const parts = url.split('/'); // Split the URL by '/'
        const secondPart = parts[parts.length - 2] // Get second last part (login/sign-up)
        const lastPart = parts[parts.length - 1]; // Get the last part (restaurant name)
        // console.log(secondPart)
        this.setState({
            currentClient: lastPart
        })
        if (lastPart == "artcaffe") {
            if (secondPart == "sign-up") {
                this.setState({
                    showSignUpPageLoading: true,
                    showNavbar: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPage: true,
                        })
                    }, 3000)
                })
            } else if (secondPart == "login") {
                this.setState({
                    showSignUpPageLoading: true,
                    showNavbar: true
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showLoginPage: true,
                        })
                    }, 5000)
                })
            }
        } else {

        }
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
          isDropdownOpen: !prevState.isDropdownOpen,
        }));
    };

    handleChange = (event) => {
        this.setState({
            [event.target.id] : event.target.value,
        })
    }

        //? - - SIGN UP INPUT FUNCTIONS - - ?//

    handleFirstNameClicked = () => {
        this.firstNameInputRef.current.focus();
        this.setState({
            firstNameBorderColor: "#321d05",
            firstNameTextColor: "#321d05"
        })

        if (this.state.email == "") {
            this.setState({
                emailBorderColor: "#ABA9A9",
                emailTextColor: "#ABA9A9"
            })
        } 

        if (this.state.lastName == "") {
            this.setState({
                lastNameBorderColor: "#ABA9A9",
                lastNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.phone == "") {
            this.setState({
                phoneBorderColor: "#ABA9A9",
                phoneTextColor: "#ABA9A9"
            })
        }

        if (this.state.password == "") {
            this.setState({
                passwordBorderColor: "#ABA9A9",
                passwordTextColor: "#ABA9A9"
            })
        }

        if (this.state.confirmPassword == "") {
            this.setState({
                confirmPasswordBorderColor: "#ABA9A9",
                confirmPasswordTextColor: "#ABA9A9"
            })
        }
    }

    handleLastNameClicked = () => {
        this.lastNameInputRef.current.focus()
        this.setState({
            lastNameBorderColor: "#321d05",
            lastNameTextColor: "#321d05"
        })

        if (this.state.email == "") {
            this.setState({
                emailBorderColor: "#ABA9A9",
                emailTextColor: "#ABA9A9"
            })
        } 

        if (this.state.firstName == "") {
            this.setState({
                firstNameBorderColor: "#ABA9A9",
                firstNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.phone == "") {
            this.setState({
                phoneBorderColor: "#ABA9A9",
                phoneTextColor: "#ABA9A9"
            })
        }

        if (this.state.password == "") {
            this.setState({
                passwordBorderColor: "#ABA9A9",
                passwordTextColor: "#ABA9A9"
            })
        }

        if (this.state.confirmPassword == "") {
            this.setState({
                confirmPasswordBorderColor: "#ABA9A9",
                confirmPasswordTextColor: "#ABA9A9"
            })
        }
    }

    handleEmailClicked = () => {
        this.emailInputRef.current.focus();
        this.setState({
            emailBorderColor: "#321d05",
            emailTextColor: "#321d05"
        })

        if (this.state.firstName == "") {
            this.setState({
                firstNameBorderColor: "#ABA9A9",
                firstNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.lastName == "") {
            this.setState({
                lastNameBorderColor: "#ABA9A9",
                lastNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.phone == "") {
            this.setState({
                phoneBorderColor: "#ABA9A9",
                phoneTextColor: "#ABA9A9"
            })
        }

        if (this.state.password == "") {
            this.setState({
                passwordBorderColor: "#ABA9A9",
                passwordTextColor: "#ABA9A9"
            })
        }

        if (this.state.confirmPassword == "") {
            this.setState({
                confirmPasswordBorderColor: "#ABA9A9",
                confirmPasswordTextColor: "#ABA9A9"
            })
        }
    }

    handlePhoneClicked = () => {
        this.phoneInputRef.current.focus();
        this.setState({
            phoneBorderColor: "#321d05",
            phoneTextColor: "#321d05"
        })

        if (this.state.firstName == "") {
            this.setState({
                firstNameBorderColor: "#ABA9A9",
                firstNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.lastName == "") {
            this.setState({
                lastNameBorderColor: "#ABA9A9",
                lastNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.email == "") {
            this.setState({
                emailBorderColor: "#ABA9A9",
                emailTextColor: "#ABA9A9"
            })
        } 

        if (this.state.password == "") {
            this.setState({
                passwordBorderColor: "#ABA9A9",
                passwordTextColor: "#ABA9A9"
            })
        }

        if (this.state.confirmPassword == "") {
            this.setState({
                confirmPasswordBorderColor: "#ABA9A9",
                confirmPasswordTextColor: "#ABA9A9"
            })
        }
    }

    handlePasswordClicked = () => {
        this.passwordInputRef.current.focus();
        this.setState({
            passwordBorderColor: "#321d05",
            passwordTextColor: "#321d05"
        })

        if (this.state.firstName == "") {
            this.setState({
                firstNameBorderColor: "#ABA9A9",
                firstNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.lastName == "") {
            this.setState({
                lastNameBorderColor: "#ABA9A9",
                lastNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.email == "") {
            this.setState({
                emailBorderColor: "#ABA9A9",
                emailTextColor: "#ABA9A9"
            })
        } 

        if (this.state.phone == "") {
            this.setState({
                phoneBorderColor: "#ABA9A9",
                phoneTextColor: "#ABA9A9"
            })
        }

        if (this.state.confirmPassword == "") {
            this.setState({
                confirmPasswordBorderColor: "#ABA9A9",
                confirmPasswordTextColor: "#ABA9A9"
            })
        }
    }

    handleConfirmPasswordClicked = () => {
        this.confirmPasswordInputRef.current.focus();
        this.setState({
            confirmPasswordBorderColor: "#321d05",
            confirmPasswordTextColor: "#321d05"
        })

        if (this.state.firstName == "") {
            this.setState({
                firstNameBorderColor: "#ABA9A9",
                firstNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.lastName == "") {
            this.setState({
                lastNameBorderColor: "#ABA9A9",
                lastNameTextColor: "#ABA9A9"
            })
        }

        if (this.state.email == "") {
            this.setState({
                emailBorderColor: "#ABA9A9",
                emailTextColor: "#ABA9A9"
            })
        } 

        if (this.state.phone == "") {
            this.setState({
                phoneBorderColor: "#ABA9A9",
                phoneTextColor: "#ABA9A9"
            })
        }

        if (this.state.password == "") {
            this.setState({
                passwordBorderColor: "#ABA9A9",
                passwordTextColor: "#ABA9A9"
            })
        }
    }

    termsCheckedClicked = () => {
        this.setState({
            showTermsChecked: false,
            showTermsUnchecked: true
        })
    }

    termsUncheckedClicked = () => {
        this.setState({
            showTermsUnchecked: false,
            showTermsChecked: true
        })
    }

    termsNotCheckedClicked = () => {
        this.setState({
            showTermsNotChecked: false,
            showTermsChecked: true
        })
    }

    handleScrollToTopOfSignUpForm = () => {
        const element = document.getElementById('topOfSignUpForm');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    handleScrollToTopOfTermAgreements = () => {
        const element = document.getElementById('topOfTermsAgreement');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    generateRandom12DigitNumber = () => {
        // Generate a random number between 10^11 and (10^12)-1
        const min = Math.pow(10, 11);
        const max = Math.pow(10, 12) - 1;
        const randomNumber = Math.floor(Math.random() * (max - min + 1) + min);
      
        return randomNumber.toString();
    };

    generateUserID = () => {
        let userIDPart1 = shortid.generate()
        let userIDPart2 = shortid.generate()
        let userId = `user-${userIDPart1}_${userIDPart2}`
        return userId
    }

    signUpBtnClicked = async () => {
        if (this.state.firstName == "") {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                firstNameBorderColor: "red",
                // firstNameTextColor: "red"
            })
        } else {
            this.setState({
                firstNameBorderColor: "#321d05",
                // firstNameTextColor: "#321d05"
            })
        }

        if (this.state.lastName == "") {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                lastNameBorderColor: "red",
                // lastNameTextColor: "red"
            })
        } else {
            this.setState({
                lastNameBorderColor: "#321d05",
                // lastNameTextColor: "#321d05"
            })
        }

        if (this.state.email == "") {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                emailBorderColor: "red",
                // emailTextColor: "red"
            })
        } else {
            this.setState({
                emailBorderColor: "#321d05",
                // emailTextColor: "#321d05"
            })
        }

        if (this.state.phone == "") {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                phoneBorderColor: "red",
                // phoneTextColor: "red"
            })
        } else {
            this.setState({
                phoneBorderColor: "#321d05",
                // phoneTextColor: "#321d05"
            })
        }

        if (this.state.password == "" || this.state.password.length < 8) {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                passwordBorderColor: "red",
                // passwordTextColor: "red"
            })
        } else {
            this.setState({
                passwordBorderColor: "#321d05",
                // passwordTextColor: "#321d05"
            })
        }

        if (this.state.confirmPassword == "") {
            this.handleScrollToTopOfSignUpForm()
            this.setState({
                confirmPasswordBorderColor: "red",
                // confirmPasswordTextColor: "red"
            })
        } else {
            this.setState({
                confirmPasswordBorderColor: "#321d05",
                // confirmPasswordTextColor: "#321d05"
            })
        }

        if (this.state.showTermsChecked == false) {
            this.setState({
                showTermsUnchecked: false,
                showTermsNotChecked: true
            })
            if (this.state.firstName != "" && this.state.lastName != "" && this.state.email != "" && this.state.phone != "" && this.state.password != "" && this.state.confirmPassword != "" && this.state.showTermsChecked == false) {
                this.handleScrollToTopOfTermAgreements()
            }
        } 

        if (this.state.firstName != "" && this.state.lastName != "" && this.state.email != "" && this.state.phone != "" && this.state.password != "" && this.state.password.length >=8 && this.state.confirmPassword != "" && this.state.showTermsChecked == true) {
            if (this.state.confirmPassword !== this.state.confirmPassword) {
                this.setState({
                    passwordBorderColor: "red",
                    // passwordTextColor: "red",
                    confirmPasswordBorderColor: "red",
                    // confirmPasswordTextColor: "red"
                }) 
            } else {
                this.setState({
                    passwordBorderColor: "#321d05",
                    // passwordTextColor: "#321d05",
                    confirmPasswordBorderColor: "#321d05",
                    // confirmPasswordTextColor: "#321d05"
                }) 

                let emailVerified = false
                let userIDVerified = false
                let cardNumberVerified = false

                try {
                    let userID;
                    do {
                        console.log("we got the doooo")
                        userID = this.generateUserID()
                    } while (!this.checkIfUserIDExists(userID))
    
                    userIDVerified = true
    
                    if (userIDVerified == true) {
                        setTimeout(() => {
                            let cardNumber;
                            do {
                                cardNumber = this.generateRandom12DigitNumber();
                            } while (!this.checkIfCardNumberExists(cardNumber));
                        }, 5000)
                        cardNumberVerified = true
                    }
    
                    if (cardNumberVerified == true) {
                        setTimeout(() => {
                            this.checkIfEmailExists(this.state.email.toLowerCase())
                            .then(() => {
                                
                            })
                        }, 10000)
                        console.log(emailVerified)
                    }
                } catch (error) {
                    console.log("error ALERT, error")
                }
            }
        }   
    }

    checkIfCardNumberExists = async (cardNumber) => {
        let cardExists = false
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("card_list")
        .doc(cardNumber)
        .get()
        .then(doc => {
            if (doc.exists) {
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "generating your loyalty card"
                }, () => {
                    setTimeout(() => {
                        
                    }, 5000)
                })
                cardExists = true
                return cardExists
            } else {
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "generating your loyalty card"
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            cardNumberVerified: true,
                            userCardNumber: cardNumber
                        })
                    }, 5000)
                })
                return cardExists
            }
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        })
    }

    checkIfUserIDExists = async (userID) => {
        let userIDExists = false
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("id_list")
        .doc(userID)
        .get()
        .then(doc => {
            if (doc.exists) {
                // if code DOES exist - display loading page
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "creating your profile"
                }, () => {
                    setTimeout(() => {
                    
                    }, 5000)
                })
                userIDExists = true
                return userIDExists
            } else {
                // if code doesn't exist - display loading page
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "creating your profile"
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            userIDVerified: true,
                            userID: userID
                        })
        
                    }, 5000)
                })
                return userIDExists
            }
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }

    checkIfEmailExists = async (userEmail) => {
        let croppedNumber = this.state.phone.substring(1);
        let areaCode = "+254"
        let areaCodeNumber = areaCode + croppedNumber
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("email_list")
        .doc(userEmail)
        .get()
        .then(doc => {
            if (doc.exists) {
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "verifying your details"
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            emailBorderColor: "red",
                            emailErrMsg: "Email is in use",
                            showSignUpPage: true
                        })
                    }, 5000)
                    setTimeout(() => {
                        this.handleScrollToTopOfSignUpForm()
                    }, 5400)
                })
            } else {
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "verifying your details"
                }, () => {
                    setTimeout(() => {
                        this.checkIfPhoneNumberExists(areaCodeNumber)
                        this.setState({
                            emailVerified: true,
                            emailBorderColor: "#321d05",
                            emailErrMsg: ""
                        })
                    }, 5000)
                })
            }
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        })
    }

    checkIfPhoneNumberExists = async (phoneNumber) => {
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("members_list")
        .collection("number_list")
        .doc(phoneNumber)
        .get()
        .then(doc => {
            if (doc.exists) {
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "finalizing verification"
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            phoneBorderColor: "red",
                            phoneErrMsg: "Number is in use",
                            showSignUpPage: true
                        })
                    }, 5000)
                    setTimeout(() => {
                        this.handleScrollToTopOfSignUpForm()
                    }, 5400)
                })
            } else {
                this.setState({
                    showSignUpPage: false,
                    showSignUpPageLoading: true,
                    loadingMessage: "finalizing verification"
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            phoneNumberVerified: true,
                            phoneBorderColor: "#321d05",
                            phoneErrMsg: "",
                            showSignUpPageLoading: false,
                            showUserMobileVerification: true,
                            showVerificationCountdown: true,
                            OTPCountdownTimer: Date.now() + 59000
                        })
                        this.addUserDataToDatabase()
                    }, 5000)
                    // setTimeout(() => {
                    //     this.sendOTPSMS()
                    // }, 6000)
                })
            }
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        })
    }

    sendOTPSMS = () => {
        // Inside handleSignUp
        let croppedNumber = this.state.phone.substring(1);
        let areaCode = "+254"
        let areaCodeNumber = areaCode + croppedNumber
    
        const appVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container", {
            size: "invisible",
            // timeOut: 60000,
        });
        
        fire.auth().signInWithPhoneNumber(areaCodeNumber, appVerifier)
        .then((confirmationResult) => {
            this.setState({
                // countdownActive: true,
                // OTPCountdownTimer: Date.now() + 59000,
                confirmationResult: confirmationResult
            })
        })
        .then((userCredential) => {
            // User is now authenticated
            this.setState({
                userCredential: userCredential
            })
            
        })
        .catch((error) => {
            console.log(error.message)
            if (error.message.includes("We have blocked all requests from this device due to unusual activity. Try again later.")){
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "troubleshooting..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "OTP limit exceeded for this device",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            } else if (error.message.includes("The project's quota for this operation has been exceeded.")) {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "troubleshooting..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "daily sign up quota exceeded",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            } else {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            }
        });
    }

    addUserToInactiveAppBucket = async () => {
        let croppedNumber = this.state.phone.substring(1);
        let areaCode = "+254"
        let areaCodeNumber = areaCode + croppedNumber
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("activity")
        .collection("inactive")
        .doc(this.state.userID)
        .set({
            id: this.state.userID,
            name: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            email: this.state.email.toLowerCase(),
            number: areaCodeNumber
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }

    addUserToInactiveOrdersBucket = async () => {
        let croppedNumber = this.state.phone.substring(1);
        let areaCode = "+254"
        let areaCodeNumber = areaCode + croppedNumber
        await fire.firestore().collection("clients")
        .doc("artcaffe")
        .collection("members")
        .doc("activity")
        .collection("notOrdered")
        .doc(this.state.userID)
        .set({
            id: this.state.userID,
            name: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            email: this.state.email.toLowerCase(),
            number: areaCodeNumber
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }
 
    handlePhoneSignUp = () => {
        const currentDate = new Date();
        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });
        const formattedDateTime = dateFormatter.format(currentDate);
        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';
        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;
        const { confirmationResult, verificationCode } = this.state;
        this.setState({
            showUserMobileVerification: false,
            showSignUpPageLoading: true,
            loadingMessage: "heading to your profile"
        }, () => {
            setTimeout(() => {
                this.setState({
                    loadingMessage: "",
                })
                if (confirmationResult && verificationCode) {
                    confirmationResult
                    .confirm(verificationCode)
                    .then(async() => {
                        const addFunctionPromises = [
                            this.addToEmailListDatabase(formattedDateTimeWithAmPm),
                            this.addToNumberListDatabase(formattedDateTimeWithAmPm),
                            this.addToIDListDatabase(formattedDateTimeWithAmPm),
                            this.addTimeOfRegistrationDatabase(formattedDateTimeWithAmPm),
                            this.addToCardListDatabase(formattedDateTimeWithAmPm),
                            this.addToSearchListDatabase(formattedDateTimeWithAmPm),
                        ];
                        // Wait for all "add..." functions to complete

                        await Promise.all(addFunctionPromises);
    
                        fire.auth().createUserWithEmailAndPassword(this.state.email, this.state.password)
                        .then((userCredential) => {
                            window.location.href = `/home/${this.state.currentClient}`
                        })
                        .catch((error) => {
                            this.setState({
                                showUserMobileVerification: false,
                                showSignUpPageLoading: true,
                            }, () => {
                                setTimeout(() => {
                                    this.setState({
                                        showSignUpPageLoading: false,
                                        showSignUpPageNetworkError: true,
                                        showNetworkReconnectionAttempt: true,
                                        showNetworkConnectionLoader: true,
                                        showBackToSignUpBtn: false,
                                        networkErrorStatus: "trying to reconnect..."
                                    })
                                }, 3000)
                            })
                            setTimeout(() => {
                                this.setState({
                                    showNetworkConnectionLoader: false,
                                    networkErrorStatus: "failed to reconnect",
                                    showBackToSignUpBtn: true,
                                    userCardNumber: "",
                                })
                            }, 13000) 
                        });
                    })
                    .catch((error) => {
                        this.setState({
                            showUserMobileVerification: false,
                            showSignUpPageLoading: true,
                        }, () => {
                            setTimeout(() => {
                                this.setState({
                                    showSignUpPageLoading: false,
                                    showSignUpPageNetworkError: true,
                                    showNetworkReconnectionAttempt: true,
                                    showNetworkConnectionLoader: true,
                                    showBackToSignUpBtn: false,
                                    networkErrorStatus: "trying to reconnect..."
                                })
                            }, 3000)
                        })
                        setTimeout(() => {
                            this.setState({
                                showNetworkConnectionLoader: false,
                                networkErrorStatus: "failed to reconnect",
                                showBackToSignUpBtn: true,
                                userCardNumber: "",
                            })
                        }, 13000)
                    });
                } else {
                    this.setState({
                        showUserMobileVerification: false,
                        showSignUpPageLoading: true,
                    }, () => {
                        setTimeout(() => {
                            this.setState({
                                showSignUpPageLoading: false,
                                showSignUpPageNetworkError: true,
                                showNetworkReconnectionAttempt: true,
                                showNetworkConnectionLoader: true,
                                showBackToSignUpBtn: false,
                                networkErrorStatus: "trying to reconnect..."
                            })
                        }, 3000)
                    })
                    setTimeout(() => {
                        this.setState({
                            showNetworkConnectionLoader: false,
                            networkErrorStatus: "failed to reconnect",
                            showBackToSignUpBtn: true,
                            userCardNumber: "",
                        })
                    }, 13000)
                }
            }, 3500)
        })
    }

    addUserDataToDatabase = async () => {
        const currentDate = new Date();
        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });
        const formattedDateTime = dateFormatter.format(currentDate);
        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';
        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;
            //? - - ADD AREA CODE TO PHONE NUMBER - - ?//
        let croppedNumber = this.state.phone.substring(1);
        let areaCode = "+254"
        let areaCodeNumber = areaCode + croppedNumber

        if (this.state.userID != "") {
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .set({
                address: "",
                cardNumber: this.state.userCardNumber,
                currentClient: this.state.currentClient,
                dataConsent: true,
                dataUploadedAt: formattedDateTimeWithAmPm,
                email: this.state.email.toLowerCase().replace(/\s/g, ''),
                emailVerified: "false",
                firstName: this.state.firstName.replace(/\s/g, ''),
                id: this.state.userID,
                lastActive: "",
                lastName: this.state.lastName.replace(/\s/g, ''),
                // password: this.state.password,
                phone: areaCodeNumber,
                registrationDate: "",
                verified: false
            })
            .then(async () => {
                await this.createUserRewardsBucket()
                await this.createUserChallengesBucket()
                await this.createUserPurhcaseHistoryBucket()
                await this.createUserSecretMenuBucket()
                await this.createUserWishListBucket()
                await this.createUserNotificationsBucket()
                await this.createUserLoyaltyCardBucket()
                this.sendOTPSMS()
            })
            .catch((error) => {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            })
        } else {
            console.log("We keep getting here")
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }
        
    }

    createReceiptsBucket = () => {
        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("list")
        .doc(this.state.userID)
        .collection("data")
        .doc("receipts")
        .set({
            id: "receipts"
        })
    }

    createUserLoyaltyCardBucket = () => {
        if (this.state.userID!="") {
            fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("pointsInfo")
            .set({
                points: 0,
                pointsTillNextReward: 0,
                earningPolicy: "",
                earningPolicyPointsValue: "",
                earningPolicyMoneyValue: "",
                earningPolicyPercentageChange: "",
                earningPolicyEndDate: ""
            })
            .catch((error) => {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            })
        } else {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }
        
    }

    createUserRewardsBucket = async () => {
        if (this.state.userID!="") {
            await fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("rewards")
            .set({
                id: "rewards",
                text: "No rewards available currently"
            })
            .catch((error) => {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            })
        } else {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }
    }

    createUserChallengesBucket = async () => {
        if (this.state.userID!=""){
            await fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("challenges")
            .set({
                id: "challenges",
                text: "No challenges available currently"
            })
            .catch((error) => {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            })
        } else {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }
        
    }

    createUserPurhcaseHistoryBucket = async () => {
        if (this.state.userID !="") {
            await fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("purchaseHistory")
            .set({
                id: "purchaseHistory",
                text: "No purchases recorded"
            })
            .catch((error) => {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            })
        } else {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }
    }

    createUserSecretMenuBucket = async () => {
        if (this.state.userID!=""){
            await fire.firestore().collection("clients")
            .doc("artcaffe")
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("secretMenu")
            .set({
                id: "secretMenu",
                text: "No secret menu items"
            })
            .catch((error) => {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            })
        } else {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }   
    }

    createUserNotificationsBucket = async () => {
        if (this.state.userID!="") {
            await fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("notifications")
            .set({
                pointsNotificationCount: 0,
                rewardsNotificationCount: 0,
                clickedNewReward: "false",
                seenNewReward: "false",
                latestReward: ""
            })
            .catch((error) => {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        })
        } else {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }
    }

    createUserWishListBucket = async () => {
        if (this.state.userID!="") {
            await fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("members_list")
            .collection("list")
            .doc(this.state.userID)
            .collection("data")
            .doc("wishList")
            .set({
                id: "wishList",
                text: "No items on your wish list"
            })
            .catch((error) => {
                this.setState({
                    showUserMobileVerification: false,
                    showSignUpPageLoading: true,
                    loadingMessage: ""
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            showSignUpPageLoading: false,
                            showSignUpPageNetworkError: true,
                            showNetworkReconnectionAttempt: true,
                            showNetworkConnectionLoader: true,
                            showBackToSignUpBtn: false,
                            networkErrorStatus: "trying to reconnect..."
                        })
                    }, 3000)
                })
                setTimeout(() => {
                    this.setState({
                        showNetworkConnectionLoader: false,
                        networkErrorStatus: "failed to reconnect",
                        showBackToSignUpBtn: true,
                        userCardNumber: "",
                    })
                }, 13000)
            })
        } else {
            this.setState({
                showUserMobileVerification: false,
                showSignUpPageLoading: true,
                loadingMessage: ""
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        }
    }

    addToEmailListDatabase = (date) => {
        const currentDate = new Date();
        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });
        const formattedDateTime = dateFormatter.format(currentDate);
        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';
        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;
        let croppedNumber = this.state.phone.substring(1);
        let areaCode = "+254"
        let areaCodeNumber = areaCode + croppedNumber
        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("email_list")
        .doc(this.state.email.toLowerCase().replace(/\s/g, ''))
        .set({
            id: this.state.userID,
            signUpTime: date,
            name: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            email: this.state.email.toLowerCase().replace(/\s/g, ''),
            number: areaCodeNumber 
        })
        .then(() => { 
            
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                    userCardNumber: "",
                })
            }, 13000)
        })
    }

    addToNumberListDatabase = (date) => {
        const currentDate = new Date();
        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });
        const formattedDateTime = dateFormatter.format(currentDate);
        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';
        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;
        let croppedNumber = this.state.phone.substring(1);
        let areaCode = "+254"
        let areaCodeNumber = areaCode + croppedNumber
        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("number_list")
        .doc(areaCodeNumber)
        .set({
            signUpTime: date,
            name: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            number: areaCodeNumber,
            id: this.state.userID,
            email: this.state.email.toLowerCase().replace(/\s/g, '')
        })
        .then(() => {
            this.addToIDListDatabase(formattedDateTimeWithAmPm)
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }

    addToIDListDatabase = (date) => {
        const currentDate = new Date();
        // Format the date to "dd/mm/yy" and the time to "hh:mm AM/PM"
        const dateFormatter = new Intl.DateTimeFormat('en-GB', {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false, // Use 24-hour format
        });
        const formattedDateTime = dateFormatter.format(currentDate);
        // Determine whether it's AM or PM based on the hour
        const amPm = currentDate.getHours() < 12 ? 'AM' : 'PM';
        // Concatenate the formatted time and AM/PM
        const formattedDateTimeWithAmPm = `${formattedDateTime} ${amPm}`;
        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("id_list")
        .doc(this.state.userID)
        .set({
            signUpTime: date,
            name: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            id: this.state.userID,
            email: this.state.email.toLowerCase()
        })
        .then(() => {
            this.addToCardListDatabase(formattedDateTimeWithAmPm)
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }

    addToCardListDatabase = (date) => {
        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("card_list")
        .doc(this.state.userCardNumber)
        .set({
            signUpTime: date,
            name: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            cardNumber: this.state.userCardNumber,
            email: this.state.email.toLowerCase()
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }

    addToSearchListDatabase = (date) => {
        let fixedLastName = this.state.lastName.replace(/\s/g, '')
        let destinationDoc = fixedLastName.charAt(0).toUpperCase()

        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("members_list")
        .collection("search_list")
        .doc(destinationDoc)
        .collection("list")
        .doc(`${this.state.lastName}-${this.state.userID}`)
        .set({
            id: this.state.userID,
            value: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            key: this.state.userCardNumber,
        })
        .then(() => {
            this.setState({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                password: "",
                confirmPassword: "",
                cardNumber: "",
                userID: "",
                emailVerified: ""
            })
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }

    addTimeOfRegistrationDatabase = (date) => {

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear().toString();

        const monthAbbreviations = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
        const currentMonth = monthAbbreviations[currentDate.getMonth()];

        const dayOfMonth = currentDate.getDate().toString();


        let fixedLastName = this.state.lastName.replace(/\s/g, '')
        let destinationDoc = fixedLastName.charAt(0).toUpperCase()

        fire.firestore().collection("clients")
        .doc(this.state.currentClient)
        .collection("members")
        .doc("registration")
        .collection(currentYear)
        .doc(currentMonth)
        .collection(dayOfMonth)
        .doc(this.state.userID)
        .set({
            id: this.state.userID,
            value: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
            card: this.state.userCardNumber,
            date: date
        })
        .then(() => {
            fire.firestore().collection("clients")
            .doc(this.state.currentClient)
            .collection("members")
            .doc("registration")
            .collection(currentYear)
            .doc(currentMonth)
            .collection("0monthlyUsers")
            .doc(this.state.userID)
            .set({
                id: this.state.userID,
                value: `${this.state.firstName.replace(/\s/g, '')} ${this.state.lastName.replace(/\s/g, '')}`,
                card: this.state.userCardNumber,
                date: date
            })
        })
        .catch((error) => {
            this.setState({
                showSignUpPage: false,
                showSignUpPageLoading: true,
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showSignUpPageLoading: false,
                        showSignUpPageNetworkError: true,
                        showNetworkReconnectionAttempt: true,
                        showNetworkConnectionLoader: true,
                        showBackToSignUpBtn: false,
                        networkErrorStatus: "trying to reconnect..."
                    })
                }, 3000)
            })
            setTimeout(() => {
                this.setState({
                    showNetworkConnectionLoader: false,
                    networkErrorStatus: "failed to reconnect",
                    showBackToSignUpBtn: true,
                })
            }, 13000)
        })
    }

    handleResendCode = () => {
        this.sendOTPSMS()
        this.setState({
            countdownActive: true,
            OTPCountdownTimer: Date.now() + 59000
        })
    }

    redirectToLoginPage = () => {
        window.location.href = `/login/${this.state.currentClient}`
    }

    redirectToSignUpPage = () => {
        window.location.href = `/sign-up/${this.state.currentClient}`
    }

    goBackToSignUpForm = () => {
        this.setState({
            showSignUpPageNetworkError: false,
            showBackToSignUpBtn: false,
            showSignUpPageLoading: true,
        }, () => {
            setTimeout(() => {
                this.setState({
                    showSignUpPageLoading: false,
                    showSignUpPage: true,
                })
            }, 3000)
        })
    }
 
    render () {

                //* - - SIGN UP STYLES - - *//

            // First name

        let firstNameInput = {
            border: `2px solid ${this.state.firstNameBorderColor}`
        }

        let firstNameLabel = {
            color: this.state.firstNameTextColor
        }

            // Last name

        let lastNameInput = {
            border: `2px solid ${this.state.lastNameBorderColor}`
        }

        let lastNameLabel = {
            color: this.state.lastNameTextColor
        }

            // Email

        let emailInput = {
            border: `2px solid ${this.state.emailBorderColor}`
        }

        let emailLabel = {
            color: this.state.emailTextColor
        }

            // Phone

        let phoneInput = {
            border: `2px solid ${this.state.phoneBorderColor}`
        }

        let phoneLabel = {
            color: this.state.phoneTextColor
        }

            // Password

        let passwordInput = {
            border: `2px solid ${this.state.passwordBorderColor}`
        }

        let passwordLabel = {
            color: this.state.passwordTextColor
        }

            // Confirm password

        let confirmPasswordInput = {
            border: `2px solid ${this.state.confirmPasswordBorderColor}`
        }

        let confirmPasswordLabel = {
            color: this.state.confirmPasswordTextColor
        }


        return (
            <Styles>
                <div className='fullPage'>
                    {this.state.showNavbar && 
                        <div className='navbar'>
                            <Container>
                                <div style={{display: "flex", justifyContent:"space-between"}}>
                                    <img style={{width: "25%", paddingTop: "3.5%", marginLeft: "2.5%"}} src='/assets/artcaffe-logo.jpg'/>
                                    {/* <h3 style={{paddingLeft: "4%", fontFamily: "sora", fontSize: "18.5px", fontWeight: "bold", paddingTop: "2%", color: "#321d05"}}>Artcaffe <label style={{marginLeft: "5px"}}>☕️</label></h3> */}
                                    <Button onClick={this.toggleDropdown}>
                                        <img className='menu-btn' src='/assets/mobile-small-phone-menu-icon-dark.png'/>
                                    </Button>
                                </div>
                                <Dropdown open={this.state.isDropdownOpen}>
                                <p style={{paddingRight: "2.5%"}}>How it works</p>
                                <p style={{paddingRight: "2.5%"}}>Terms & Privacy</p>
                                {/* <p style={{paddingRight: "2.5%"}}>Rewards</p>
                                <p style={{paddingRight: "2.5%"}}>More Options</p> */}
                                </Dropdown>
                            </Container>
                        </div>
                    }
                    {this.state.showSignUpPage && 
                        <div className='signUpPage'>
                            <div className='registrationHeader'>
                                <h1>{this.state.signUpHeader}</h1>
                                <h2 id='topOfSignUpForm'>{this.state.signUpSubheader}</h2>
                            </div>
                            <div className='inputStyle'>
                                <div className='inputBox' onClick={this.handleFirstNameClicked} style={firstNameInput}>
                                    <h5 style={firstNameLabel}>First name</h5>
                                    <input
                                    id='firstName'
                                    placeholder='Wanjohi'
                                    value={this.state.firstName}
                                    onChange={this.handleChange}
                                    onClick={this.handleFirstNameClicked}
                                    ref={this.firstNameInputRef}
                                    />
                                </div>
                            </div>
                            <div className='inputStyle'>
                                <div className='inputBox' onClick={this.handleLastNameClicked} style={lastNameInput}>
                                    <h5 style={lastNameLabel}>Last name</h5>
                                    <input
                                    id='lastName'
                                    placeholder='Amani'
                                    value={this.state.lastName}
                                    onChange={this.handleChange}
                                    onClick={this.handleLastNameClicked}
                                    ref={this.lastNameInputRef}
                                    />
                                </div>
                            </div>
                            <div className='inputStyle'>
                                <div className='inputBox' onClick={this.handleEmailClicked} style={emailInput}>
                                    <h5 style={emailLabel}>Email <label>{this.state.emailErrMsg}</label></h5>
                                    <input
                                    id='email'
                                    placeholder='wanjohi.amani@gmail.com'
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    onClick={this.handleEmailClicked}
                                    ref={this.emailInputRef}
                                    />
                                </div>
                            </div>
                            <div className='inputStyle'>
                                <div className='inputBox' onClick={this.handlePhoneClicked} style={phoneInput}>
                                    <h5 style={phoneLabel}>Phone no. <label>{this.state.phoneErrMsg}</label></h5>
                                    <input
                                    id='phone'
                                    type='number'
                                    placeholder='0712345678'
                                    value={this.state.phone}
                                    onChange={this.handleChange}
                                    onClick={this.handlePhoneClicked}
                                    ref={this.phoneInputRef}
                                    autoComplete="off"
                                    />
                                </div>
                            </div>
                            <div className='inputStyle'>
                                <div className='inputBox' onClick={this.handlePasswordClicked} style={passwordInput}>
                                    <h5 style={passwordLabel}>Password (Min. 8 characters)</h5>
                                    <input
                                    id='password'
                                    type='password'
                                    placeholder='Enter your password'
                                    value={this.state.password}
                                    onChange={this.handleChange}
                                    onClick={this.handlePasswordClicked}
                                    ref={this.passwordInputRef}
                                    />
                                </div>
                            </div>
                            <div id='topOfTermsAgreement' className='inputStyle'>
                                <div className='inputBox' onClick={this.handleConfirmPasswordClicked} style={confirmPasswordInput}>
                                    <h5 style={confirmPasswordLabel}>Confirm password</h5>
                                    <input
                                    id='confirmPassword'
                                    type='password'
                                    placeholder='Confirm your password'
                                    value={this.state.confirmPassword}
                                    onChange={this.handleChange}
                                    onClick={this.handleConfirmPasswordClicked}
                                    ref={this.confirmPasswordInputRef}
                                    />
                                </div>
                            </div>
                            <div className='inputStyle'>
                                <div className='termsAgreement'>
                                    <div className='termsAgreementCol1'>
                                        {this.state.showTermsUnchecked && 
                                            <img onClick={this.termsUncheckedClicked} src='/assets/earningPolicyUnchecked.png'/> 
                                        }
                                        {this.state.showTermsChecked && 
                                            <img onClick={this.termsCheckedClicked} src='/assets/earningPolicyChecked.png'/> 
                                        }
                                        {this.state.showTermsNotChecked && 
                                            <img onClick={this.termsNotCheckedClicked} src='/assets/termsAgreementUnchecked.png'/>
                                        }
                                    </div>
                                    <div className='termsAgreementCol2'>
                                        <p>I agree to <label>Terms & Privacy</label></p>
                                    </div>
                                </div>
                            </div>
                            <div className='signUpBtn'>
                                <button
                                onClick={this.signUpBtnClicked}
                                >Sign Up</button>
                            </div>
                            <div className='loginAlternative'>
                                <div className='loginSeparator'>
                                    <div className='loginSeparatorCol1'>
                                        <div className='theSeparatorLine'></div>
                                    </div>
                                    <div className='loginSeparatorCol2'>
                                        <p>OR</p>
                                    </div>
                                    <div className='loginSeparatorCol3'>
                                        <div className='theSeparatorLine'></div>
                                    </div>
                                </div>
                                <div className='signUpBtn'>
                                    <button
                                    onClick={this.redirectToLoginPage}
                                    >Login</button>
                                </div>
                            </div>
                            <div className='footer'>
                                <p>© 2023</p>
                            </div>
                            {/* <input/> */}
                            {/* <button
                            onClick={this.login}
                            >Login</button> */}
                        </div>
                    }
                    {this.state.showUserMobileVerification && 
                        <div className='signUpPageVerification'>
                            <div className='registrationHeader'>
                                <h1>Enter your SMS verfication code</h1>
                            </div>
                            <div className='verificationInfo'>
                                {this.state.showVerificationCountdown && 
                                    <div>
                                        {this.state.countdownActive ? (
                                            <Countdown
                                            date={this.state.OTPCountdownTimer}
                                            renderer={({ minutes, seconds, completed }) => {
                                                if (completed) {
                                                    // Countdown has completed, set countdownActive to false
                                                    setTimeout(() => {
                                                    this.setState({ countdownActive: false });
                                                    }, 0);
                                                }

                                                return (
                                                    <div className='resendOTP'>
                                                    {this.state.countdownActive ? (
                                                        <p>Your OTP code should appear in the next</p>
                                                    ) : (
                                                        <button onClick={this.handleResendCode}>Resend Code</button>
                                                    )}
                                                    <p>{seconds} seconds</p>
                                                    </div>
                                                );
                                            }}
                                            />
                                        ) : (
                                            <div className='resendOTP'>
                                                <button onClick={this.handleResendCode}>Resend Code</button>
                                            </div>
                                        )}
                                        {/* <div className='resendOTP'>
                                           <p>Your OTP code will be sent shortly</p>
                                        </div> */}
                                    </div>
                                }
                                {/* {this.state.showResendOTP && 
                                    <div className='resendOTP'>
                                        <button
                                        >Resend Code</button>
                                    </div>
                                } */}
                            </div>
                            <div id="recaptcha-container"></div>
                            <div className='verificationInput'>
                                <input
                                id='verificationCode'
                                value={this.state.verificationCode}
                                onChange={this.handleChange}
                                />
                            </div>
                            <div className='signUpBtn'>
                                <button
                                onClick={this.handlePhoneSignUp}
                                >Verify</button>
                            </div>
                            <div className='footer'>
                                <p>© 2023</p>
                            </div>
                        </div>
                    }
                    {this.state.showSignUpPageLoading && 
                        <div className='signUpPageLoading'>
                            <ClipLoader
                            color="#321d05"
                            loading={true}
                            // cssOverride={override}
                            size={40}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                            />
                            <p>{this.state.loadingMessage}</p>
                        </div>
                    }
                    {this.state.showLoginPage && 
                        <LoginComponentSm dataSentFromParent={this.state.currentClient}/>
                    }
                    {this.state.showSignUpPageNetworkError &&
                        <div className='signUpPageError'>
                            <img src='/assets/no-internet.png'/>
                            <h4>network connection lost</h4>
                            {this.state.showNetworkReconnectionAttempt && 
                                <div>
                                    <p>{this.state.networkErrorStatus}</p>
                                    {this.state.showNetworkConnectionLoader && 
                                        <div className='reconnectionLoading'>
                                            <ClipLoader
                                            color="#0930cb"
                                            loading={true}
                                            // cssOverride={override}
                                            size={10}
                                            aria-label="Loading Spinner"
                                            data-testid="loader"
                                            />
                                        </div>
                                    }
                                </div>
                            }
                            {this.state.showBackToSignUpBtn && 
                                <button
                                onClick={this.goBackToSignUpForm}
                                >Back to Sign Up</button>
                            }
                        </div>
                    }
                </div>
            </Styles>
        )
    }
}